;(function() {
  'use strict'

  angular.module('app.core').component('channelInfoPlaces', {
    controller: Controller,
    templateUrl: 'channel-info-places.html',
    bindings: {
      channel: '<',
      onSave: '&',
    },
  })

  /* @ngInject */
  function Controller() {
    // ...
    var ctrl = this

    ctrl.$onInit = onInit

    function onInit() {
      // ...
    }
  }
})()
